import { Breadcrumb } from 'antd';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import useGetCurrentResource from './useGetCurrentResource';
import { useSelector } from 'react-redux';
import { getResources } from 'react-admin';

const Breadcrumbs = ({ path }: { path: string }) => {
    const currentResource = useGetCurrentResource();
    const { pathname } = useLocation();
    const resources = useSelector(getResources);
    const splitPaths = path.replace(/[\/\\]/, '').split('/').filter(segment => segment !== '');

    if (splitPaths.length < 1) {
        return <></>
    }

    // Find the current resource and its parent if it has a feature
    const currentResourceName = pathname.replace(/[\/\\]/, '').split('/')[0];
    const currentResourceObj = resources.find((r: any) => r.name === currentResourceName);
    const feature = currentResourceObj?.options?.feature;

    // Find parent resource with matching feature and label
    let parentResource: any = null;
    if (feature && currentResourceObj?.options?.viewMode === false) {
        parentResource = resources.find((r: any) =>
            r.options?.feature === feature &&
            r.options?.label &&
            r.options?.viewMode !== false
        );
    }

    const breadcrumbItems: any[] = [
        {
            key: 'home',
            title: <NavLink to="/">Home</NavLink>,
        },
    ];

    if (parentResource) {
        breadcrumbItems.push({
            key: 'parent',
            title: <NavLink to={`/${parentResource.name}`}>{parentResource.options.label}</NavLink>,
        });
    }

    splitPaths.forEach((subPath, idx) => {
        const crumbName = idx == 0 ? (currentResourceObj?.options?.label || currentResource) : subPath;
        if (splitPaths.length == idx + 1) {
            breadcrumbItems.push({ key: idx, title: crumbName });
        } else {
            breadcrumbItems.push({ key: idx, title: <NavLink to={`/${subPath}`}>{crumbName}</NavLink> });
        }
    });

    return (
        <Breadcrumb
            separator="/"
            style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            items={breadcrumbItems}
        />
    )
}

export default Breadcrumbs;